import React from "react";
import "../assets/css/Contact.css";
import InnerHeader from "./InnerHeader";
import FooterSection from '../components/FooterSection';


const Contact = () => {

    return (


        <>

            <InnerHeader />

            <div className="contact-page">

                {/* HERO */}

                <section className="contact-hero">

                    <h1>Contact</h1>
                    <p>
                        Invite Indrajeet Patil for seminars,
                        leadership workshops and business training programs.
                    </p>

                </section>


                {/* CONTACT GRID */}

                <div className="contact-container">

                    {/* FORM */}

                    <div className="contact-form">

                        <h2>Send an Enquiry</h2>

                        <form>

                            <input
                                type="text"
                                placeholder="Full Name"
                            />

                            <input
                                type="email"
                                placeholder="Email Address"
                            />

                            <input
                                type="text"
                                placeholder="Phone Number"
                            />

                            <input
                                type="text"
                                placeholder="Organisation / Company"
                            />

                            <select>

                                <option>Select Event Type</option>
                                <option>Seminar</option>
                                <option>Workshop</option>
                                <option>Corporate Training</option>
                                <option>Guest Lecture</option>

                            </select>

                            <textarea
                                placeholder="Message"
                                rows="4"
                            />

                            <button type="submit">
                                Send Enquiry
                            </button>

                        </form>

                    </div>


                    {/* CONTACT INFO */}

                    <div className="contact-info">

                        <h2>Contact Information</h2>

                        <p>
                            For seminar bookings, training programs
                            and collaboration opportunities,
                            feel free to reach out.
                        </p>

                        <div className="info-item">
                             Phone
                            <span>+91 XXXXX XXXXX</span>
                        </div>

                        <div className="info-item">
                             Email
                            <span>contact@indrajeetpatilindia.com</span>
                        </div>

                        <div className="info-item">
                          Location
                            <span>Pune, Maharashtra, India</span>
                        </div>

                    </div>

                </div>

            </div>





          <FooterSection />


        </>

    );

};

export default Contact;